export default "__VITE_ASSET__B9Dw5rLZ__"